export const AZURE_AUTHENTICATION_SCOPES = [
  'user.read', 'user.readBasic.all',
];
